<p-listbox class="h-[150px]"
           [options]="groupedItems" [group]="true"
           [(ngModel)]="selectedItems"
           optionLabel="name" dataKey="dataKey"
           optionGroupLabel="name" optionGroupChildren="items" optionDisabled="isReadOnly"
           [multiple]="true" [checkbox]="true" [showToggleAll]="false" [highlightOnSelect]="false"
           (onChange)="onSelectionChange()"
           scrollHeight="150px"
           [pt]="{ list: { class: 'p-0!' }, optionGroup: { class: 'border-b border-surface rounded-none' }}" >
  <ng-template let-group #group>
    <div class="flex items-center gap-2">
      <i class="pi pi-warehouse"></i>
      <span>{{ group.name }}</span>
    </div>
  </ng-template>

  <ng-template pTemplate="item" let-item>
    <div class="flex items-center gap-2">
      <span>{{ item.name }}</span>
    </div>
  </ng-template>
</p-listbox>
